import React, { useState } from 'react';
import {
  DragDropContext,
  Draggable,
  Droppable,
  DropResult,
} from 'react-beautiful-dnd';
import { Card, Icon } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { DraggableComponentI } from './types';
import './styles.css';

function DraggableComponent(props: DraggableComponentI) {
  const {
    droppableId,
    className,
    list,
    editHandler,
    settingsHandler,
    cardClickHandler,
    onDragEndHandler,
  } = props;

  const { commonStore } = useStore();

  const [selectedId, setSelectedId] = useState('');

  const onDragEnd = (result: DropResult) => {
    onDragEndHandler(result);
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div
            className={className}
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {list?.map((data, index: number) => {
              return (
                <Draggable
                  data-is-dragging={false}
                  key={data.id}
                  draggableId={data.id}
                  index={index}
                >
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <Card>
                        <Card.Content
                          className={`cardWrapper ${
                            data.id === selectedId ? 'cardWrapper-selected' : ''
                          }`}
                          onClick={() => {
                            setSelectedId(data.id);
                            cardClickHandler(data.id, index, data.type || '');
                          }}
                          key={data.id}
                        >
                          <div
                            style={{
                              display: 'flex',
                            }}
                            {...provided.dragHandleProps}
                          >
                            <Icon
                              style={{
                                cursor: 'all-Scroll',
                                fontSize: '15px',
                                marginTop: '2px',
                              }}
                              name="ellipsis vertical"
                              color="grey"
                              size="small"
                            />
                            <Icon
                              style={{
                                cursor: 'all-Scroll',
                                fontSize: '15px',
                                left: 7,
                                position: 'absolute',
                                marginTop: '2px',
                              }}
                              name="ellipsis vertical"
                              color="grey"
                              size="small"
                            />
                          </div>
                          <div>{data.name}</div>
                          <div className="cardEditWrapper">
                            {!commonStore.filterModeTwo.includes(
                              'DYDC-EDIT',
                            ) && (
                              <Icon
                                name="pencil"
                                color="grey"
                                size="small"
                                disabled={commonStore.filterModeZero.includes(
                                  'DYDC-EDIT',
                                )}
                                onClick={(e: {
                                  stopPropagation: () => void;
                                }) => {
                                  e.stopPropagation();
                                  editHandler(data, index);
                                }}
                              />
                            )}
                            {!commonStore.filterModeTwo.includes(
                              'DYDC-DELETE',
                            ) && (
                              <Icon
                                name="trash"
                                color="grey"
                                size="small"
                                disabled={commonStore.filterModeZero.includes(
                                  'DYDC-DELETE',
                                )}
                                onClick={(e: any) => {
                                  e?.stopPropagation();
                                  cardClickHandler(
                                    data.id,
                                    index,
                                    data.type || '',
                                    true,
                                  );
                                }}
                              />
                            )}
                            {!commonStore.filterModeTwo.includes(
                              'DYDC-SETTING',
                            ) && (
                              <Icon
                                name="settings"
                                color="grey"
                                size="small"
                                disabled={commonStore.filterModeZero.includes(
                                  'DYDC-SETTING',
                                )}
                                onClick={(e: {
                                  stopPropagation: () => void;
                                }) => {
                                  e.stopPropagation();
                                  settingsHandler(data, index);
                                }}
                              />
                            )}
                          </div>
                        </Card.Content>
                      </Card>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default React.memo(DraggableComponent);
